import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/cancelamento-resultado`

    return {
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        list(queryParms = {}) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        destroy(id, queryParms) {
            return repository.delete(`${baseUrl}/${id}?${urlUtil.serialize(queryParms)}`)
        },
        loadFields(queryParms = {}) {

            return repository.get(`${baseUrl}/load-field?${urlUtil.serialize(queryParms)}`)
        },
    }
}
